import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Container, Stack, Typography, CircularProgress } from '@mui/material'
import ButtonComponent from '@professocial/professocialFormComponents/FormComponents/ButtonComponent'
import Env from '../../../config/envConfig'

const RegisterConfirmSuccess: React.FC = () => {
  const { t } = useTranslation()
  const history = useHistory()

  // ES-998: Nach Klick auf den Bestätigungslink hat das Backend bereits eine
  // Session angelegt (Auto-Login). Prüfen, ob eine Session besteht, und den
  // Nutzer in diesem Fall direkt ins eingeloggte Dashboard leiten. Besteht keine
  // Session (Auto-Login nicht verfügbar oder fehlgeschlagen), wird wie bisher die
  // Bestätigungsseite mit Verweis auf den Login angezeigt.
  const [checkingSession, setCheckingSession] = useState(true)

  useEffect(() => {
    const controller = new AbortController()
    fetch(`${Env.restBase}/rest/professocial/core/gatekeeper/auth/current`, {
      method: 'GET',
      credentials: 'include',
      headers: { Accept: 'application/json' },
      signal: controller.signal,
    })
      .then(res => (res.ok ? res.json() : Promise.reject(res)))
      .then(user => {
        if (user && user.id) {
          // gleiche Signalkette wie beim regulären Login (userLogin.done):
          // localStorage-Marker setzen und das ProfessocialUser-Event feuern,
          // damit die App den eingeloggten Zustand übernimmt.
          window.localStorage.setItem('user', user.id)
          window.dispatchEvent(new CustomEvent('ProfessocialUser', { detail: user }))
          history.push('/')
        } else {
          setCheckingSession(false)
        }
      })
      .catch(() => setCheckingSession(false))
    return () => controller.abort()
  }, [])

  if (checkingSession) {
    return (
      <Container component='main' maxWidth='xs'>
        <Stack spacing={4} textAlign='center' alignItems='center' sx={{ mt: '50px' }}>
          <CircularProgress />
        </Stack>
      </Container>
    )
  }

  return (
    <Container component='main' maxWidth='xs'>
      <Stack spacing={4} textAlign='center' sx={{ mt: '50px' }}>
        <Typography variant='h2'>{t('login:registerConfirmSuccessHeadline')}</Typography>
        <Typography>{t('login:registerConfirmSuccessText')}</Typography>
        <ButtonComponent
          fullWidth
          variant='contained'
          color='primary'
          text={t('login:registerConfirmSuccessButton')}
          onClick={() => history.push('/login')}
        />
      </Stack>
    </Container>
  )
}

export default RegisterConfirmSuccess
